<app-dashboard-card title="Action Items">
	<button
		dashboardCardActions
		type="button"
		class="task-follow-ups-header-button"
		title="View your follow-ups"
		(click)="onViewFollowUps()"
	>
		<span>Follow-ups</span>

		<span class="task-follow-ups-header-count">
			{{ followUpCount }}
		</span>
	</button>
	<div class="task-actions-explainer">
		Claim tasks to add them to your review queue.
		You currently have
		<strong>{{ outstandingCount }}</strong>
		{{ outstandingCount === 1 ? 'claimed task' : 'claimed tasks' }}
		available for review.
	</div>
	<div class="task-actions">
		<div class="task-action">
			<div class="task-action-title">
				Unclaimed Tasks
			</div>

			<button
				title="Click to claim all unclaimed tasks"
				type="button"
				class="task-action-button task-action-claim"
				[disabled]="unclaimedCount === 0 || isClaiming"
				(click)="onClaimAll()"
			>
				<span>
	        {{ isClaiming ? 'Claiming...' : 'Claim All Tasks' }}
        </span>

				<span class="task-action-count">
					{{ unclaimedCount }}
				</span>
			</button>
		</div>

		<div class="task-action-divider"></div>

		<div class="task-action">
			<div class="task-action-title">
				Outstanding Tasks
			</div>

			<button
				title="Click to review outstanding tasks"
				type="button"
				class="task-action-button task-action-review"
				[disabled]="outstandingCount === 0"
				(click)="onReviewTasks()"
			>
				<span>Review Tasks</span>

				<span class="task-action-count">
					{{ outstandingCount }}
				</span>
			</button>
		</div>
	</div>

	<div class="task-actions-expand">
		<button
			title="Click to select unclaimed tasks"
			type="button"
			class="task-actions-expand-link"
			(click)="onExpandUnclaimed()"
		>
			Expand to select Unclaimed Tasks
			<i class="pi pi-arrow-right"></i>
		</button>
	</div>
</app-dashboard-card>
